export enum RoleplayViewMode {
  List = "list",
  Column = "column",
}
